export default __webpack_public_path__ + "static/media/bike.90e649d8.svg";